// extracted by mini-css-extract-plugin
export default {"main":"styles_main__mnKa8","google":"styles_google__Xyixt","iframe":"styles_iframe__vTeru"};